/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
} from '@mui/material';
import { RefreshCw, Check } from 'lucide-react';

interface ModelPickerProps {
  selectedModel: string;
  originalModel: string;
  onChange: (model: string) => void;
  onReset: () => void;
  onSave: () => void;
  availableModels?: Array<{ key: string; name: string }>;
}

export const ModelPicker: React.FC<ModelPickerProps> = ({
  selectedModel,
  originalModel,
  onChange,
  onReset,
  onSave,
  availableModels = [],
}) => {
  const [isModified, setIsModified] = useState(false);

  useEffect(() => {
    setIsModified(selectedModel !== originalModel);
  }, [selectedModel, originalModel]);

  const handleChange = (model: string) => {
    onChange(model);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel>Model Preset</InputLabel>
        <Select
          value={selectedModel || ''}
          onChange={e => handleChange(e.target.value as string)}
          label="Model Preset"
        >
          {availableModels.map(model => (
            <MenuItem key={model.key} value={model.key}>
              {model.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {isModified && (
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <Tooltip title="Reset to database value">
            <IconButton
              size="small"
              onClick={onReset}
              sx={{ color: 'grey.600' }}
            >
              <RefreshCw />
            </IconButton>
          </Tooltip>

          <Tooltip title="Save to database">
            <IconButton
              size="small"
              onClick={onSave}
              sx={{ color: 'success.main' }}
            >
              <Check />
            </IconButton>
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};
